import SearchView from '@shared/components/search/View'

export default function install(Vue) {
  Vue.component(SearchView.name, SearchView)
}



// WEBPACK FOOTER //
// ./src/js/shared/components/search/index.js